export enum InverterManufacturerEnum {
    // supported
    ENPHASE = 'enphase',
    SOLAREDGE = 'solaredge',
    GENERAC = 'generac',
    TESLA = 'tesla',

    // unsupported
    SOLAREDGE_ALTERNATIVE = 'solaredge_alternative',
    GENERAC_ALTERNATIVE = 'generac_alternative',
    AP_SYSTEMS = 'ap_systems',
    SOL_ARK = 'sol_ark',
    HOYMILES = 'hoymiles',
    NEP = 'nep',
    PANASONIC = 'panasonic',
    FRANKLINWH = 'franklinwh',
    SONNEN = 'sonnen',
    TIGO = 'tigo',
    SMA = 'sma',
    FOXESS = 'foxess',
    POINTGUARD = 'pointguard',
    QCELLS = 'qcells',
    FORTRESS = 'fortress',
    EG4 = 'eg4',
    LUNAR_ENERGY = 'lunar_energy',
    ECOFLOW = 'ecoflow',
    CANADIAN_SOLAR = 'canadian_solar',
    // unknown
    OTHER = 'other'
}
